import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { useAlliedQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/allied/pageStore';
import { ALLIED_PROPOSAL_INFO_FORM_ID } from './constants';

const AlliedQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions },
    domainProductLineItems,
    isDomainProductLinesLoading,
  } = useAlliedQuoteProposalInfoPageStore();

  return (
    <IMFormStyled id={ALLIED_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled />

      <FollowingSectionTitleStyled title="Additional Information" />
      <IMSicSearch label="SIC Code" size="full" disabled />

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default AlliedQuoteProposalInfoForm;
